/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import React, {Component} from 'react'
import {Redirect, Route, withRouter} from 'react-router-dom'
import {connect} from 'react-redux'

import {Routes} from '../utils/Routes'
import {userHasActivity} from './SecurityUtils'
import {ACTIVITY_TYPES} from "./SecurityConst";

class PrivateRoute extends Component {
    render() {
        const {userProfile, component: Component, access, ...rest} = this.props
        let authenticated = false
        let count = 0

        // If user has EXTERNAL_ACTIVITY -> it means that is external user (from CAMP or Airtime)
        // then this user need to have restricted everything what has no EXTERNAL_ACTIVITY access
        if (userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)) {
            // If access restriction is not defined, external user need to have it forbidden
            if (access == null) {
                authenticated = false;
            }
            // if access is defined, external user has it forbidden if there is not EXTERNAL_ACTIVITY access included
            else {
                authenticated = access.filter(a => a === ACTIVITY_TYPES.EXTERNAL_ACTIVITY).length !== 0;
            }
        }
        else {
            if (access == null) {
                authenticated = true
            }
            else {
                access.forEach( a => {
                    if (userHasActivity(this.props.userProfile, a)) {
                        count++
                    }
                })

                if (count === access.length) {
                    authenticated = true
                }
            }
        }


        return (
            <Route {...rest} render={props => (
                authenticated ?
                    <Component {...props}/> : <Redirect to={{pathname: Routes.LOGIN, state: {from: props.location}}}/>
            )}/>
        )
    }
}

const mapStateToProps = ({security}) => {
    return {
        userProfile: !security ? null : security.userProfile,
    }
}

export default withRouter(connect(mapStateToProps)(PrivateRoute))
